import { Box, Typography } from '@gmm/ui';
import { FC } from 'react';
import { SxProps, Theme } from '@mui/material';

interface Props {
  // true: "EXACT PROBLEM", right side
  // false: "RANDOM SAMPLE", left side
  exact: boolean;
}

const boxStylesExact: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  right: 0,
  width: '120px',
  height: '120px',
  backgroundColor: 'primary.main',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  clipPath: 'polygon(100% 0, 0 0, 100% 100%)',
};

const boxStylesRandom: SxProps<Theme> = {
  ...boxStylesExact,
  left: 0,
  clipPath: 'polygon(100% 0, 0 0, 0 100%)',
};

const innerBoxStylesExact: SxProps<Theme> = {
  transform: 'rotate(45deg) translateY(-25px)',
  transformOrigin: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
};

const innerBoxStylesRandom: SxProps<Theme> = {
  ...innerBoxStylesExact,
  transform: 'rotate(-45deg) translateY(-23px)',
};

const typographyStyles: SxProps<Theme> = {
  color: 'white',
  fontWeight: 'bold',
  fontSize: '18px',
  lineHeight: 1,
  letterSpacing: '0.1em',
  textAlign: 'center',
};

const ExactProblemTriangle = (
  <Box sx={boxStylesExact}>
    <Box sx={innerBoxStylesExact}>
      <Typography sx={typographyStyles}>EXACT</Typography>
      <Typography sx={typographyStyles}>PROBLEM</Typography>
    </Box>
  </Box>
);

const RandomSampleTriangle = (
  <Box sx={boxStylesRandom}>
    <Box sx={innerBoxStylesRandom}>
      <Typography sx={typographyStyles}>RANDOM</Typography>
      <Typography sx={typographyStyles}>SAMPLE</Typography>
    </Box>
  </Box>
);

export const SampleTypeTriangle: FC<Props> = ({ exact }) => {
  return exact ? ExactProblemTriangle : RandomSampleTriangle;
};
